/**
 * 首页标题4
 */

import { Row, Col } from 'antd';

const HH2 = () => {
    return <>
        <div style={{ backgroundColor: '#fff', marginTop: '30px' }}>
            <Row>
                <Col offset={4} span={16} style={{ textAlign: 'center' }}>
                    <h1>新闻动态</h1>
                    <p>了解公司动态及行业资讯</p>
                </Col>
            </Row>
        </div>
    </>
}

export default HH2;